import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price)
}

export function formatWeight(weight?: string | number): string {
  if (!weight) return '';
  const weightStr = String(weight).trim();
  if (!weightStr) return '';
  if (/(?:gm|gms|g|gram|grams)$/i.test(weightStr)) {
    return weightStr;
  }
  return `${weightStr}gm`;
}

export function formatPurity(purity?: string | number, category?: string): string {
  if (!purity) return '';
  let purityStr = String(purity).trim();
  if (!purityStr) return '';
  
  const isGold = category?.toLowerCase().includes('gold');
  const numericVal = parseFloat(purityStr);
  
  if (isGold || (!isNaN(numericVal) && numericVal <= 24)) {
    if (/(?:karat|karats)$/i.test(purityStr)) {
      return purityStr;
    }
    if (/k$/i.test(purityStr)) {
      purityStr = purityStr.slice(0, -1).trim();
    }
    return `${purityStr} Karat`;
  }
  return purityStr;
}


export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}